export default __webpack_public_path__ + "static/foyer-maconnerie-7c8dc1f4d1576e6b1e3380adc069aa1d.jpg";